import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

import { generateWiresChart } from "./Charts";

import Subtitle from "@/components/Subtitle";
import TitleXl from "@/components/TitleXl";
import { useAppSelector } from "@/context/hooks";

export default function WiresCharts() {
  const { t } = useTranslation();
  const globalValues = useAppSelector((state: any) => state);

  return (
    <View className="w-full border border-gray rounded-lg mt-4 p-4 items-center shadow">
      <View className="mb-4">
        <TitleXl text={t("management/customer:charts.wires.title")} />
        <View className="mt-2">
          <Subtitle text={t("management/customer:charts.wires.subtitle")} />
        </View>
      </View>
      <View className="flex-col items-center">
        {generateWiresChart(
          globalValues.transactions !== undefined && globalValues.transactions !== null ? globalValues.transactions : []
        )}
      </View>
    </View>
  );
}
